<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Lista de facturas programadas</h3>
            </div>
        </div>
        <div class="card">
            <div class="card__content">
                <div class="row">
                    <div class="col-xs-12">
                        <table>
                            <thead>
                                <tr>
                                    <th>Tipo de programación</th>
                                    <th># Documento</th>
                                    <th>Fecha de emisión</th>
                                    <th>Cliente</th>
                                    <th>IVA</th>
                                    <th>Total</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(comprobante, index) in comprobantes" :key="index">
                                    <td>{{ comprobante.descripcion_tipo_programacion }}</td>
                                    <td>{{ comprobante.numero_documento }}</td>
                                    <td>{{ comprobante.fecha_emision }}</td>
                                    <td>{{ comprobante.nombre_cliente }}</td>
                                    <td>{{ comprobante.valor_iva }}</td>
                                    <td>{{ comprobante.valor_total }}</td>
                                    <td>
                                        <button @click="clonar(comprobante.id_comprobante)" class="btn-success btn--text" type="button">
                                            <i class="fa fa-clone"></i>
                                        </button>
                                        <button @click="anular(comprobante.id_comprobante)" class="btn-danger btn--text" type="button">
                                            <i class="fa fa-calendar"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-show="comprobantes.length === 0">
                                    <td colspan="7"><strong>No hay comprobantes programados.</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>            
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data : function () {
        return {
            comprobantes : [],
            form : {
                tipo_programacion : 'P',
                mes : '1'
            },
            url : url
        };
    },
    methods : {
        consultarComprobantes : function () {
            let that = this;
            axios.get(this.url + '/comprobantes/programacion', {
                params : this.form
            }).then(function (response) {
                that.comprobantes = response.data;
            }).catch(function () {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        clonar : function (id) {
            window.open(this.url + '/comprobantes/' + id + '/clonar?programado=S', '_blank');
        },
        anular : function (id) {
            let that = this;
            swal({
                title: '¿Desea anular este comprobante programado?',
                text: "Esta acción requiere de confirmación.",
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Anular',
                cancelButtonText : 'No'
            }).then(function (result) {
                if (result.value) {
                    axios.post(that.url + '/comprobantes/' + id + '/anular-programacion', {
                        _method : 'DELETE'
                    }).then(function () {
                        swal('Se anuló la programación del comprobante.', 'Realizado', 'success');
                        that.consultarComprobantes();
                    }).catch(function () {
                        swal('Hubo un error, intente nuevamente.', 'error');
                    });
                }
            })
        }
    },
    mounted : function () {
        this.consultarComprobantes();
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ListaFacturasProgramadas.vue